import React from 'react'
import Button from './Button'
const ClientCatch = () => {
  return (
    <div className='client'>
          <div className="clientCatch">
        <span>
            it will help improve your writing & bring your ideas to life
        </span>
        <Button text="start 14 days trial" style={{
            padding:"15px",
            background:"white"
        }}/>
      </div>
    </div>
  )
}

export default ClientCatch